// src/components/ProtectedRoute.js

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Spinner from '../components/common/Spinner/Spinner';
import TrocarSenhaObrigatoria from '../pages/TrocarSenhaObrigatoria';

const ProtectedRoute = ({ children, requiredProfile, isAllowed }) => {
    const { currentUser, loading } = useAuth();

    if (loading) {
        return <Spinner text="A verificar permissões..." fullScreen />;
    }

    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    if (currentUser.mustChangePassword === true) {
        return <TrocarSenhaObrigatoria />;
    }

    if (isAllowed && !isAllowed(currentUser)) {
        return <Navigate to="/dashboard" replace />;
    }

    if (requiredProfile && currentUser.perfil !== requiredProfile) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;
